import { useState } from 'react';

const faqs = [
  {
    question: '什么是po文网站？如何选择适合自己的平台？',
    answer: 'po文网站是指提供原创内容发布服务的在线平台，创作者可以在上面发布小说、文章、笔记等内容。选择平台时，建议从内容类型匹配度、读者群体特征、变现能力、成长空间和使用体验五个维度综合考量。例如写小说推荐晋江或起点，写生活方式内容推荐小红书，做知识分享推荐知乎。',
  },
  {
    question: '新人作者如何快速积累第一批读者？',
    answer: '新人积累读者需要做好三件事：一是找准内容定位，选择1-2个核心平台深耕；二是保持稳定的更新频率，建议每周至少更新2-3篇；三是主动参与平台活动，与其他作者互动，在社交媒体分享创作内容。通常在坚持3-6个月后，就能积累起第一批忠实读者。',
  },
  {
    question: '在po文网站发布内容需要付费吗？',
    answer: '绝大多数主流po文网站都提供免费发布服务。像番茄小说、简书、Lofter、知乎等平台完全免费使用，注册即可开始创作。部分平台如微信公众号需要300元/年的认证费用，但这主要用于开通更多高级功能。创作者可以根据预算选择合适的平台。',
  },
  {
    question: '如何通过po文网站实现内容变现？',
    answer: '内容变现主要有四种模式：广告分成（如番茄小说、今日头条）、付费阅读（如起点中文网、知乎盐选）、粉丝打赏（如微信公众号、B站）和品牌合作（如小红书）。建议先从广告分成和打赏开始，等积累一定粉丝后拓展品牌合作。部分平台的头部作者月收入可达数万元。',
  },
  {
    question: '多个平台同时发布内容可以吗？作品版权如何处理？',
    answer: '建议新人先选择1-2个核心平台深耕，等积累一定基础后再扩展。关于版权，大多数平台采用非独家授权模式，创作者保留作品版权，可以在多个平台发布。但需要注意：部分平台的签约协议可能要求独家授权，签约前务必仔细阅读合同条款。同一作品在多平台发布时，建议保持各平台的内容一致性。',
  },
  {
    question: 'po文网站发布的内容审核严格吗？如何避免被限流？',
    answer: '不同平台的审核标准有所不同。晋江、起点等文学平台对内容尺度有明确限制；知乎、今日头条等综合平台对政治敏感内容管控严格。建议发布前仔细阅读各平台的创作规范，避免涉及敏感话题、尊重知识产权、不使用违规引流方式。合规创作是长期发展的基础。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900">
            常见问题解答
          </h2>
          <p className="mt-3 text-foreground-500">
            关于po文网站的常见疑问，这里都有答案
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-background-50 border border-background-200 rounded-xl overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-100/50 transition-colors"
              >
                <span className="text-sm font-semibold text-foreground-800 pr-4">
                  {faq.question}
                </span>
                {openIndex === index ? (
                  <i className="ri-arrow-up-s-line text-foreground-400 flex-shrink-0"></i>
                ) : (
                  <i className="ri-arrow-down-s-line text-foreground-400 flex-shrink-0"></i>
                )}
              </button>
              {openIndex === index && (
                <div className="px-5 pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}